import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Shanki Invoice'

export default function getPageTitle(pageTitle) {
    if (pageTitle) {
        return `${pageTitle} | ${title}`
    }
    return `${title}`
}